import { combineReducers } from "redux";
import IncbotFeedback from "./incbotFeedbackReducer";

const appReducer = combineReducers({ IncbotFeedback });

const reducers = (state: any, action: any) => {
  return appReducer(state, action);
};

export default reducers;
